import * as React from 'react';
import { Flex } from '../../../../designSystem/compositeComponents/FlexHelpers';
import { Icon } from '../../../../designSystem/icons/Icons';

import { AnimatedCollapsibleContent } from '../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import styled from 'styled-components';
import { H2 } from '../../../../designSystem/typography/Heading';
import { colors } from '../../../../designSystem/colors/color';
import { buildTranslator, CustomFormInputField } from '../../../../amorg-common';
import { Label } from '../../../../designSystem/Label';
import { CustomFormFieldCardColored } from './CustomFormFieldCard';


export type CustomFormFieldHeaderProps = {
    field:CustomFormInputField
    variant?:'label'
}
export function CustomFormFieldHeader(props: CustomFormFieldHeaderProps): JSX.Element {
    

    const translator = buildTranslator('da');

    const HeaderVariant = props.variant === 'label' ? Label : H2;

    return (
        <>
            {props.field.helpText 
                ? <CollapsibleDescription label={translator(props.field.header)} description={translator(props.field.helpText)} />
                : <HeaderTag variant={props.variant}><HeaderVariant>{translator(props.field.header)}</HeaderVariant></HeaderTag>
            }
        </>
    );
}


type CollapsibleDescriptionProps = {

    label:string,
    description:string,
}
export function CollapsibleDescription(props:CollapsibleDescriptionProps):JSX.Element
{
    const [open, setOpen] = React.useState(false);

    return (
    <>
    <HoverCollapsible onClick = {() => setOpen(!open)}>
        <Flex justifyContent="space-between">
            <H2>{props.label}</H2>
            <Flex>
                <Icon name={open ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown'} />
                <Icon name='survey_question' />
            </Flex>
        </Flex>
    </HoverCollapsible>
        
    <AnimatedCollapsibleContent open={open}>
        <CustomFormFieldCardColored variant="light">
            <div dangerouslySetInnerHTML={{ __html: props.description || '' }} />
        </CustomFormFieldCardColored>
    </AnimatedCollapsibleContent>
    </>
    )
}

const HeaderTag = styled.div<{variant?:'label'}>`
    margin-bottom: ${ props => props.variant === 'label' ? 0 : 8}px;
    padding: ${ props => props.variant === 'label' ? "8px 8px 0 8px" : "8px"};
`

const HoverCollapsible = styled.div `
    border-bottom: 1px solid white;
    border-top: 1px solid white;
    margin-bottom: 8px;
    padding: 8px;

    transition: all 0.3s ease;

    &:hover {
        background: ${colors.customForm.answer.formFieldHeader.backgroundHover};
        border-bottom: 1px solid ${colors.customForm.answer.formFieldHeader.borderHover};
        border-top: 1px solid ${colors.customForm.answer.formFieldHeader.borderHover};
        cursor: pointer;
    }
`